import Vue from 'vue'
import gpxPlanner from '@/DocGPXPlanner.vue'

const defaultIcon = 'mdi-content-copy'
export default Vue.component('CopyableLink', {
    components: {
        gpxPlanner
    },
    props: {
        url: {type: String, required: true}
    },
    data: () => ({
        icon: defaultIcon
    }),
    methods: {
        async copy() {
            await navigator.clipboard.writeText(this.url)
            this.icon = 'mdi-check'
            setTimeout(() => this.icon = defaultIcon, 1500)
        }
    }
})